import { Box, Pressable } from '@rbilabs/universal-components';

import { getDesignToken, spacing } from 'styles/constants';
export const StyledPressable = Pressable.withConfig({
  padding: '$4',
  backgroundColor: getDesignToken('background-card'),
  borderRadius: 8,
  marginBottom: spacing.$0_5,
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
});

export const IconContainer = Box.withConfig({
  padding: 1.5,
  marginRight: '$3',
  backgroundColor: getDesignToken('icon-active'),
  borderRadius: 'full',
});
